angular.module('cian.serp.item')
.controller('NoteEditorCtrl', ["$scope", "close", "OfferService", function ($scope, close, OfferService) {

  $scope.target = 'offer';

  $scope.$watch('target', function(value) {
    if (!$scope.offer) return;
    $scope.note = (value === 'offer'?$scope.offer.note.text:$scope.offer.user.note.text);
    _updateButtons();
  });


  $scope.saveNote = function() {
    if ($scope.target === 'offer') {
      OfferService.saveNote($scope.offer, $scope.note);
    } else if ($scope.target === 'user') {
      OfferService.saveUserNote($scope.offer, $scope.note);
    }
    close();
  };

  $scope.targetChanged = function(value) {
    $scope.target = value;
  };

  $scope.removeNote = function(){
    $scope.note = '';
    $scope.saveNote();
    close();
  };

  function _updateButtons() {
    $scope.isNoteExist = !!$scope.note;
  }

  $scope.targetChanged($scope.target);
}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.noteEditor.js
// module id = 495
// module chunks = 0